import type { ProgressRecord } from "./types";

export const MASTERY_THRESHOLD = 2;
export const WRONG_PENALTY = 3;

export function applyAnswer(
  prev: ProgressRecord,
  isCorrect: boolean,
  now: number,
): ProgressRecord {
  if (prev.state === "mastered") {
    return prev;
  }

  if (isCorrect) {
    const remainingCorrect = Math.max(0, prev.remainingCorrect - 1);
    const consecutiveCorrect = prev.consecutiveCorrect + 1;
    const state = remainingCorrect === 0 ? "mastered" : prev.state === "fresh" ? "in_progress" : prev.state;
    return {
      ...prev,
      remainingCorrect,
      consecutiveCorrect,
      state,
      totalAsked: prev.totalAsked + 1,
      totalCorrect: prev.totalCorrect + 1,
      lastSeenAt: now,
      lastAnsweredCorrect: true,
    };
  }

  return {
    ...prev,
    remainingCorrect: WRONG_PENALTY,
    consecutiveCorrect: 0,
    state: "wrong",
    totalAsked: prev.totalAsked + 1,
    totalWrong: prev.totalWrong + 1,
    lastSeenAt: now,
    lastAnsweredCorrect: false,
  };
}
